import React, { useState } from 'react';
import QuickStats from '../components/QuickStats';
import UserProfileCard from '../components/UserProfileCard';
import AllUsersTable from '../components/AllUsersTable';
import Pagination from '../components/Pagination';
import usePendingDecisions from '../hooks/usePendingDecisions';
import axiosInstance from '../../config/axiosInstance';
import { toast } from 'react-toastify';

const AdminTradeControl = () => {
  const [uid, setUid] = useState('');
  console.log(uid);
  const [userData, setUserData] = useState(null);
  console.log(userData);
  const [activeTab, setActiveTab] = useState('individual');
  const [activeTrades, setActiveTrades] = useState([]);
  const [loadingActiveTrades, setLoadingActiveTrades] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const [demoBalanceForm, setDemoBalanceForm] = useState({
    uid: '',
    currencyCode: 'USDT',
    newDemoBalance: '',
    reason: '',
  });
  const { trades } = usePendingDecisions();

  const fetchUser = async (id) => {
    try {
      const lookup = typeof id === 'string' && id.length > 0 ? id : uid;
      const trimmed = (lookup || '').toString().trim();
      console.log('Fetching user with ID:', trimmed);

      if (!trimmed) {
        toast.error('Please enter a User UID before fetching.');
        setUserData(null);
        return;
      }

      try {
        console.log('Attempting to fetch user by UID:', trimmed);
        const response = await axiosInstance.get(
          `/api/admin/users?search=${trimmed}`
        );
        console.log('User API Response:', response.data);

        if (response.data.success && response.data.data) {
          const payload = response.data.data;
          const users = payload.users || [];

          if (users.length > 0) {
            const apiUser = users[0];
            console.log('Found user:', apiUser);

            const user = {
              id: apiUser.id,
              uid: apiUser.uid,
              email: apiUser.email || '',
              name: apiUser.fullName || apiUser.email?.split('@')[0] || 'User',
              fullName: apiUser.fullName || '',
              phone: apiUser.phone,
              role: apiUser.role,
              status: apiUser.status,
              kycStatus: apiUser.kycStatus,
              country: apiUser.country,
              profilePicture: apiUser.profilePicture,
              vipLevel: apiUser.vipLevel,
              creditScore: apiUser.creditScore,
              forcedTradeOutcome: apiUser.forcedTradeOutcome,
              todaysEarnings: apiUser.todaysEarnings,
              createdAt: apiUser.createdAt,
              updatedAt: apiUser.updatedAt,
            };
            console.log('Processed user data:', user);
            setUserData(user);
            toast.success('User loaded successfully!');
            return;
          } else {
            throw new Error('User not found');
          }
        }
      } catch (apiError) {
        console.log(
          'API fetch failed, trying pending trades:',
          apiError.response?.data || apiError.message
        );

        // Fallback to pending trades from usePendingDecisions hook
        const match = Array.isArray(trades)
          ? trades.find(
              (t) =>
                t.user?.uid === trimmed ||
                t.user?.id === trimmed ||
                t.userId === trimmed ||
                t.userEmail === trimmed ||
                t.id === trimmed
            )
          : null;

        if (match) {
          const apiUser = match.user;
          if (apiUser) {
            const user = {
              id: apiUser.id,
              uid: apiUser.uid || match.uid || apiUser.id,
              email: apiUser.email || match.userEmail || '',
              name: apiUser.fullName || apiUser.email?.split('@')[0] || 'User',
              fullName: apiUser.fullName || '',
              tradingBalance: apiUser.tradingBalance,
              profitLoss: match.profitLoss,
              tradeId: match.id,
              symbol: match.symbol,
              tradeType: match.tradeType,
              amount: match.amount,
              entryPrice: match.entryPrice,
              exitPrice: match.exitPrice,
              status: match.status,
              durationSeconds: match.durationSeconds,
              expiresAt: match.expiresAt,
              userWinPercentage: match.userWinPercentage,
              randomNumber: match.randomNumber,
              autoResult: match.autoResult,
              adminDecision: match.adminDecision,
              result: match.result,
              outcomeReason: match.outcomeReason,
              decidedBy: match.decidedBy,
              decidedAt: match.decidedAt,
              createdAt: match.createdAt,
            };
            setUserData(user);
            toast.success('User loaded from pending trades!');
          } else {
            setUserData(null);
            toast.error('User not found in database or pending trades');
          }
        } else {
          setUserData(null);
          toast.error('User not found in database or pending trades');
        }
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      toast.error('Error fetching user.');
    }
  };

  const updateTradeMode = async (outcome, reason = '') => {
    try {
      if (!userData || !userData.uid) {
        toast.error('No user selected');
        return;
      }

      const response = await axiosInstance.post(
        '/api/admin/users/update-trading-settings',
        {
          uid: userData.uid,
          forcedTradeOutcome: outcome,
          reason: reason || 'Admin trade control decision',
        }
      );

      if (response.data.success) {
        setUserData({
          ...userData,
          forcedTradeOutcome: outcome,
        });
        toast.success(`Trade outcome set to ${outcome} successfully!`);
      }
    } catch (error) {
      console.error('Error updating trade settings:', error);
      toast.error('Failed to update trade settings.');
    }
  };

  const fetchActiveTrades = async () => {
    try {
      setLoadingActiveTrades(true);
      const response = await axiosInstance.get('/api/trading/active-trades');

      if (response.data.success) {
        setActiveTrades(response.data.data.trades || []);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error('Error fetching active trades:', error);
      toast.error('Failed to fetch active trades');
    } finally {
      setLoadingActiveTrades(false);
    }
  };

  const handleDemoBalanceSubmit = async () => {
    try {
      if (!demoBalanceForm.uid) {
        toast.error('Please enter User UID');
        return;
      }

      const response = await axiosInstance.post(
        '/api/admin/users/update-demo-balance',
        demoBalanceForm
      );

      if (response.data.success) {
        toast.success('Demo balance updated successfully!');
        setDemoBalanceForm({
          uid: '',
          currencyCode: 'USDT',
          newDemoBalance: '',
          reason: '',
        });
      }
    } catch (error) {
      console.error('Error updating demo balance:', error);
      toast.error(
        error.response?.data?.message || 'Failed to update demo balance'
      );
    }
  };

  return (
    <div className='container-fluid mt-4 px-2 px-md-3'>
      <h3 className='mb-4'>Advanced Trade Control</h3>

      <QuickStats />

      {/* Tab Buttons */}
      <div
        className='mb-3 d-grid d-md-flex flex-wrap gap-2'
        style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}
      >
        <button
          className={`btn ${
            activeTab === 'individual' ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => setActiveTab('individual')}
        >
          Individual
        </button>
        <button
          className={`btn ${
            activeTab === 'activeTrades' ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => {
            setActiveTab('activeTrades');
            fetchActiveTrades();
          }}
        >
          Active Traders
        </button>
        <button
          className={`btn ${
            activeTab === 'allUsers' ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => setActiveTab('allUsers')}
        >
          All Users
        </button>

        <button
          className={`btn ${
            activeTab === 'demoBalance' ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => setActiveTab('demoBalance')}
        >
          Demo Balance
        </button>
      </div>

      {activeTab === 'individual' ? (
        // Individual User Control
        <>
          <div className='mb-3' style={{ maxWidth: '450px' }}>
            <input
              type='text'
              className='form-control'
              placeholder='Enter User UID (e.g., 2247777)'
              value={uid}
              onChange={(e) => setUid(e.target.value)}
            />
            <button
              className='btn btn-primary mt-2 me-2'
              onClick={() => fetchUser()}
            >
              Fetch User
            </button>
          </div>
          {userData && (
            <div className='row'>
              <UserProfileCard
                userData={userData}
                updateTradeMode={updateTradeMode}
              />
            </div>
          )}
        </>
      ) : activeTab === 'activeTrades' ? (
        // Active Traders
        <div className='card shadow-sm border-0'>
          <div className='card-header bg-white border-bottom py-3'>
            <div className='d-flex justify-content-between align-items-center'>
              <h5 className='mb-0 fw-semibold'>Active Traders</h5>
              <button
                className='btn btn-sm btn-primary'
                onClick={fetchActiveTrades}
                disabled={loadingActiveTrades}
              >
                {loadingActiveTrades ? 'Loading...' : 'Refresh'}
              </button>
            </div>
          </div>
          <div className='card-body p-0'>
            {loadingActiveTrades ? (
              <div className='text-center py-4'>
                <div className='spinner-border text-primary' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
              </div>
            ) : activeTrades.length === 0 ? (
              <div className='text-center py-4 text-muted'>
                No active trades found
              </div>
            ) : (
              <div className='table-responsive'>
                <table className='table table-hover align-middle mb-0'>
                  <thead className='table-light'>
                    <tr>
                      <th className='text-start ps-3 py-3'>UID</th>
                      <th className='text-start py-3'>User</th>
                      <th className='text-start py-3'>Asset</th>
                      <th className='text-start py-3'>Type</th>
                      <th className='text-start py-3'>Amount</th>
                      <th className='text-start py-3'>Entry Price</th>
                      <th className='text-start py-3'>Current Price</th>
                      <th className='text-start py-3'>P&L</th>
                      <th className='text-start py-3'>Time Remaining</th>
                      <th className='text-start py-3'>Status</th>
                      <th className='text-start py-3'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeTrades
                      .slice(
                        (currentPage - 1) * rowsPerPage,
                        currentPage * rowsPerPage
                      )
                      .map((trade) => (
                        <tr
                          key={trade.id}
                          style={{ borderBottom: '1px solid #f0f0f0' }}
                        >
                          <td className='text-start ps-3 py-3'>
                            <small className='font-monospace text-muted'>
                              {trade.userUid || 'N/A'}
                            </small>
                          </td>
                          <td className='text-start py-3'>
                            <div className='fw-semibold'>
                              {trade.userName || trade.userEmail}
                            </div>
                          </td>
                          <td className='text-start py-3'>
                            <strong>{trade.symbol}</strong>
                            <div>
                              <small className='text-muted'>
                                {trade.cryptocurrencyName}
                              </small>
                            </div>
                          </td>
                          <td className='text-start py-3'>
                            <span
                              className={`badge ${
                                trade.tradeType === 'LONG'
                                  ? 'bg-success'
                                  : 'bg-danger'
                              }`}
                            >
                              {trade.tradeType}
                            </span>
                          </td>
                          <td className='text-start py-3'>
                            <span className='fw-bold text-primary'>
                              ${trade.amount}
                            </span>
                          </td>
                          <td className='text-start py-3'>
                            $
                            {typeof trade.entryPrice === 'number'
                              ? trade.entryPrice.toFixed(6)
                              : 'N/A'}
                          </td>
                          <td className='text-start py-3'>
                            $
                            {typeof trade.currentPrice === 'number'
                              ? trade.currentPrice.toFixed(6)
                              : 'N/A'}
                          </td>
                          <td className='text-start py-3'>
                            <span
                              className={
                                trade.currentProfitLoss >= 0
                                  ? 'text-success fw-bold'
                                  : 'text-danger fw-bold'
                              }
                            >
                              {trade.currentProfitLoss >= 0 ? '+' : ''}
                              {typeof trade.currentProfitLoss === 'number'
                                ? trade.currentProfitLoss.toFixed(2)
                                : '0.00'}
                            </span>
                          </td>
                          <td className='text-start py-3'>
                            <div className='d-flex flex-column'>
                              <span className='fw-semibold'>
                                {trade.timeRemainingFormatted}
                              </span>
                              <small className='text-muted'>
                                {trade.duration}
                              </small>
                            </div>
                          </td>
                          <td className='text-start py-3'>
                            <span
                              className={`badge ${
                                trade.isExpired ? 'bg-secondary' : 'bg-success'
                              }`}
                            >
                              {trade.status}
                            </span>
                          </td>
                          <td className='text-start py-3'>
                            <button
                              className='btn btn-sm btn-primary rounded-pill px-3'
                              onClick={() => {
                                setUid(trade.userUid);
                                setActiveTab('individual');
                                fetchUser(trade.userUid);
                              }}
                            >
                              Manage
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          {/* Pagination */}
          {!loadingActiveTrades && activeTrades.length > rowsPerPage && (
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(activeTrades.length / rowsPerPage)}
              onPageChange={setCurrentPage}
              totalItems={activeTrades.length}
              itemsPerPage={rowsPerPage}
            />
          )}
        </div>
      ) : activeTab === 'allUsers' ? (
        // All Users Overview
        <AllUsersTable
          onManage={(userId) => {
            setUid(userId);
            setActiveTab('individual');
            fetchUser(userId);
          }}
        />
      ) : (
        <div className='card shadow-sm'>
          <div className='card-body'>
            <h5 className='card-title mb-4'>Add Demo Balance</h5>
            <div className='mb-3'>
              <label className='form-label'>User UID</label>
              <input
                type='text'
                className='form-control'
                placeholder='Enter User UID'
                value={demoBalanceForm.uid}
                onChange={(e) =>
                  setDemoBalanceForm({
                    ...demoBalanceForm,
                    uid: e.target.value,
                  })
                }
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>Currency Code</label>
              <select
                className='form-select'
                value={demoBalanceForm.currencyCode}
                onChange={(e) =>
                  setDemoBalanceForm({
                    ...demoBalanceForm,
                    currencyCode: e.target.value,
                  })
                }
              >
                <option value='USDT'>USDT</option>
                <option value='BTC'>BTC</option>
                <option value='ETH'>ETH</option>
                <option value='USD'>USD</option>
              </select>
            </div>
            <div className='mb-3'>
              <label className='form-label'>New Demo Balance</label>
              <input
                type='number'
                className='form-control'
                placeholder='Enter amount'
                value={demoBalanceForm.newDemoBalance}
                onChange={(e) =>
                  setDemoBalanceForm({
                    ...demoBalanceForm,
                    newDemoBalance: parseFloat(e.target.value) || 0,
                  })
                }
              />
            </div>
            <div className='mb-3'>
              <label className='form-label'>Reason</label>
              <textarea
                className='form-control'
                rows='3'
                placeholder='Enter reason for adding balance'
                value={demoBalanceForm.reason}
                onChange={(e) =>
                  setDemoBalanceForm({
                    ...demoBalanceForm,
                    reason: e.target.value,
                  })
                }
              ></textarea>
            </div>
            <div className='d-flex gap-2'>
              <button
                type='button'
                className='btn btn-secondary'
                onClick={() => {
                  setDemoBalanceForm({
                    uid: '',
                    currencyCode: 'USDT',
                    newDemoBalance: '',
                    reason: '',
                  });
                }}
              >
                Reset Form
              </button>
              <button
                type='button'
                className='btn btn-success'
                onClick={handleDemoBalanceSubmit}
              >
                Add Balance
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideInDown { from { transform: translateY(-40px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        @keyframes scaleIn { from { transform: scale(0); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      `}</style>
    </div>
  );
};

export default AdminTradeControl;
